export const validationRegex = {
  signup: {
    firstName: /^\s*.{2,50}\s*$/,
    lastName: /^\s*.{2,50}\s*$/,
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]{3,}\.[a-zA-Z]{3,}$/,
    password: /^.{8,100}$/,
    phone: /^(201[0125][0-9]{8}|2001[0125][0-9]{8})$/,
  },

  otp: {
    otp: /^\d{6}$/,
  },

  signin: {
    email: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    password: /^.{8,100}$/,
  },
};
